import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { GetSubscriptionCountDto } from "../../../models/analytics/dto/get-subscription-count.dto";

export const GET_SUBSCRIPTION_COUNT_QUERY_KEY = 'subscriptionCount';

export const useGetSubscriptionCount = (organizationId: string, startDate?: Date, endDate?: Date) => {
    const apiClient = useApiClient();
    return useQuery<GetSubscriptionCountDto>({
        queryKey: [GET_SUBSCRIPTION_COUNT_QUERY_KEY, organizationId, startDate, endDate],
        queryFn: async () => {
            const dateSuffix = startDate && endDate ? `&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}` : '';
            return apiClient.fetchApi<GetSubscriptionCountDto, {}>({ method: 'GET', endpoint: `analytics/subscription-count?organizationId=${organizationId}${dateSuffix}` });
        },
        enabled: !!organizationId,
        staleTime: 5 * 60 * 1000,
    });
}
